import { State } from '../configure-store';

export const getActiveToastName = (state: State) =>
  state.activeToast.toastName;

export const getActiveToastParams = (state: State) =>
  state.activeToast.params;
